import React from 'react'

const UserActivities = () => {
  return <div>UserActivities</div>
}

export default UserActivities
